import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { logout, setActiveDialog } from "ducks/app";
import { saveUserRequest } from "ducks/data";
import { Menu, Dropdown, Avatar, Badge } from "antd";
import * as Consts from "../../../../config";
import { Input } from "antd";
import axios from "axios";
import HelpModal from "./helpModal";

const Search = Input.Search;
const _ = require("lodash");

const helpUrl =
  "https://wiki.humancaresolutions.com/rest/searchv3/1.0/search?where=AHD&pageSize=5&highlight=false&queryString=";

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logout,
      push,
      setActiveDialog,
      saveUserRequest
    },
    dispatch
  );

const mapStateToProps = (state, props) => {
  const { app, routing } = state;
  return {
    pathname: routing.location.pathname
  };
};

@connect(
  mapStateToProps,
  mapDispatchToProps
)
class HelpMenu extends React.Component {
  state = {
    count: 7,
    spinnerShow: false,
    results: []
  };
  search = e => {
    let searchQuery = e.target.value;
    this.setState({ spinnerShow: true });
    if (!searchQuery) {
      this.setState({ results: [], spinnerShow: false });
      this.results = [];
    } else {
      axios
        .get(helpUrl + encodeURIComponent(searchQuery), {
          headers: {
            Accept: "application/json",
            "Content-Type": "text/plain"
          },
          bypassUserIdentityService: true
        })
        .then(response => {
          if (response.data) {
            this.setState({
              results: response.data.results,
              spinnerShow: false
            });
          }
        })
        .catch(error => {
          this.setState({ spinnerShow: false, results: [] });
        });
    }
  };

  helpLinks = [
    {
      name: "Need help with Patients?",
      reference: "/patients",
      icon: "patient",
      link: "https://wiki.humancaresolutions.com/x/1AE6"
    },
    {
      name: "Need help with your Patient?",
      reference: "/patients/",
      icon: "patient",
      link: "https://wiki.humancaresolutions.com/x/1AE6"
    },
    {
      name: "Need help with your Dashboard?",
      reference: "/",
      icon: "dashboard",
      link: "https://wiki.humancaresolutions.com/x/xgE6"
    },
    {
      name: "Need help with your Dashboard?",
      reference: "/dashboard",
      icon: "dashboard",
      link: "https://wiki.humancaresolutions.com/x/xgE6"
    },
    {
      name: "Need help with Conditions?",
      reference: "/conditions",
      icon: "condition",
      link: "https://wiki.humancaresolutions.com/x/yAE6"
    },
    {
      name: "Need help with Flows?",
      reference: "/programs",
      icon: "flow",
      link: "https://wiki.humancaresolutions.com/x/ygE6"
    },
    {
      name: "Need help with Media?",
      reference: "/library",
      icon: "media",
      link: "https://wiki.humancaresolutions.com/x/zgE6"
    },
    {
      name: "Need help with Items?",
      reference: "/tasks",
      icon: "task-tick",
      link: "https://wiki.humancaresolutions.com/x/zAE6"
    },
    {
      name: "Need help with Account Setup?",
      reference: "/accounts",
      icon: "user",
      link: "https://wiki.humancaresolutions.com/x/0gE6"
    }
  ];

  setSelectedUrl = url => {
    this.setState({
      selectedUrl: url
    });
  };

  render() {
    const { pathname } = this.props;

    let pageSpecificHelps = this.helpLinks
      .filter(l => l.reference === pathname)
      .map(l => (
        <Menu.Item onClick={() => this.setSelectedUrl(l.link)}>
          <div className="rfq__widget__system-status__item my-2">
            <i className={`icon icon-${l.icon}`} /> {l.name}
          </div>
        </Menu.Item>
      ));

    let searchHelp = (
      <Menu.Item disabled>
        <Search
          placeholder="How can we help?"
          onChange={value => this.search(value)}
          autoFocus
          allowClear={true}
        />
      </Menu.Item>
    );

    let searchHelpStatus = this.state.spinnerShow ? (
      <Menu.Item disabled>
        <i className={`fa fa-circle-o-notch fa-spin fa-fw`} /> finding help
      </Menu.Item>
    ) : this.state.results.length > 0 ? (
      <Menu.Item disabled>
        <i className={`fa fa-search`} /> Results
      </Menu.Item>
    ) : (
      undefined
    );

    let searchHelpResults = this.state.results.map(res => (
      <Menu.Item
        onClick={() =>
          this.setSelectedUrl(`https://wiki.humancaresolutions.com/${res.url}`)
        }
      >
        <div className="rfq__widget__system-status__item my-2 pl-4">
          {res.title}
        </div>
      </Menu.Item>
    ));

    const menu = (
      <Menu selectable={false}>
        {searchHelp}
        {searchHelpStatus}
        {searchHelpResults}
        <Menu.Divider />
        {pageSpecificHelps}
        <Menu.Divider />

        <Menu.Item
          onClick={() =>
            this.setSelectedUrl("https://wiki.humancaresolutions.com/x/0AE6")
          }
        >
          <div className="rfq__widget__system-status__item my-2">
            <i className={`icon fa fa-question`} /> Frequently Asked Questions
          </div>
        </Menu.Item>
        <Menu.Item
          onClick={() =>
            this.setSelectedUrl("https://wiki.humancaresolutions.com/x/1gE6")
          }
        >
          <div className="rfq__widget__system-status__item my-2">
            <i className={`icon fa fa-phone`} /> Getting Help &amp; Support
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          onClick={() =>
            this.setSelectedUrl("https://wiki.humancaresolutions.com/x/2gE6")
          }
        >
          <div className="rfq__widget__system-status__item my-2">
            <i className={`icon fa fa-gavel`} /> Regulatory Information
          </div>
        </Menu.Item>
        <Menu.Item
          onClick={() =>
            this.setSelectedUrl("https://wiki.humancaresolutions.com/x/3AE6")
          }
        >
          <div className="rfq__widget__system-status__item my-2">
            <i className={`icon fa fa-code`} /> Release Information
          </div>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className="topbar__dropdown d-inline-block  mx-4">
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <a className="ant-dropdown-link" href="/">
            <i className="icon icon-help fa-2x" />
            <span className="">Help</span>
          </a>
        </Dropdown>
        <HelpModal
          url={this.state.selectedUrl}
          show={this.state.selectedUrl !== undefined}
          onCancel={() => {
            this.setState({ selectedUrl: undefined });
          }}
        />
      </div>
    );
  }
}

export default HelpMenu;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/HelpMenu/index.js